import { render } from "./Patrimony.vue?vue&type=template&id=647961a5"
import script from "./Patrimony.vue?vue&type=script&lang=js"
export * from "./Patrimony.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__